'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _package = require('../package.json');

var _package2 = _interopRequireDefault(_package);

var _carousel = require('./container/carousel');

var _carousel2 = _interopRequireDefault(_carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

console.info('[' + process.env.NODE_ENV + '#' + process.env.APP_ENV + ']::[' + _package2.default.name + '@' + _package2.default.version + ']');

exports.default = _carousel2.default;


//////////////////
// WEBPACK FOOTER
// ./~/rcw-carousel/lib/index.js
// module id = 2270
// module chunks = 0